import api from './api';
import { LearningProgress, Certificate } from '../types';

export const userService = {
  getProfile: async () => {
    const response = await api.get('/users/profile');
    return response.data;
  },

  getLearningProgress: async () => {
    const response = await api.get('/users/progress');
    return response.data as LearningProgress;
  },

  getCertificates: async () => {
    const response = await api.get('/users/certificates');
    return response.data;
  },

  updateProfile: async (data: { name: string }) => {
    const response = await api.put('/users/profile', data);
    return response.data;
  },

  changePassword: async (data: { currentPassword: string; newPassword: string }) => {
    const response = await api.put('/users/change-password', data);
    return response.data;
  },
}; 